module.exports = __webpack_public_path__ + "static/img/user-info.1f06b7a4.png";